(function () {
  'use strict';

  var GENERATED_START = '--- Product notes ---';
  var GENERATED_END = '--- End product notes ---';
  var syncing = false;
  var syncAgain = false;

  function cleanText(value) {
    return typeof value === 'string' ? value.trim() : '';
  }

  function getProperty(properties, wantedKey) {
    if (!properties || typeof properties !== 'object') return '';

    var key = Object.keys(properties).find(function (candidate) {
      return candidate.toLowerCase() === wantedKey.toLowerCase();
    });

    return key ? cleanText(properties[key]) : '';
  }

  function stripGeneratedSection(note) {
    var text = cleanText(note);
    var start = text.indexOf(GENERATED_START);
    if (start === -1) return text;

    var end = text.indexOf(GENERATED_END, start + GENERATED_START.length);
    if (end === -1) return text.slice(0, start).trim();

    return (text.slice(0, start) + text.slice(end + GENERATED_END.length)).trim();
  }

  function buildProductNotes(items) {
    return (Array.isArray(items) ? items : [])
      .map(function (item) {
        var note = getProperty(item.properties, 'Note');
        if (!note) return '';

        var type = getProperty(item.properties, 'Note Type');
        var title = cleanText(item.product_title) || cleanText(item.title) || 'Product';
        var variant = cleanText(item.variant_title);

        if (variant && variant.toLowerCase() !== 'default title') {
          title += ' (' + variant + ')';
        }

        return (type ? title + ' — ' + type : title) + '\n' + note;
      })
      .filter(Boolean)
      .join('\n\n');
  }

  async function syncOrderNote() {
    if (syncing) {
      syncAgain = true;
      return;
    }

    syncing = true;

    try {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var cartResponse = await fetch(root + 'cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });

      if (!cartResponse.ok) throw new Error('Cart read failed: ' + cartResponse.status);

      var cart = await cartResponse.json();
      var manualNote = stripGeneratedSection(cart.note || '');
      var productNotes = buildProductNotes(cart.items);
      var generatedSection = productNotes
        ? GENERATED_START + '\n' + productNotes + '\n' + GENERATED_END
        : '';
      var nextNote = [manualNote, generatedSection].filter(Boolean).join('\n\n');

      if (cleanText(cart.note || '') === cleanText(nextNote)) return;

      var updateUrl =
        typeof routes !== 'undefined' && routes.cart_update_url
          ? routes.cart_update_url
          : root + 'cart/update.js';

      var updateResponse = await fetch(updateUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ note: nextNote })
      });

      if (!updateResponse.ok) throw new Error('Cart note update failed: ' + updateResponse.status);
    } catch (error) {
      console.error('[Behuli] Could not copy product notes to the order Notes card.', error);
    } finally {
      syncing = false;
      if (syncAgain) {
        syncAgain = false;
        syncOrderNote();
      }
    }
  }

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        syncOrderNote();
      });
    }

    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches('[name="note"]')) {
        window.setTimeout(syncOrderNote, 750);
      }
    });

    if (document.querySelector('cart-items')) {
      syncOrderNote();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

/* Behuli — Gift Box Packing: maximum one per cart/order. */
(function () {
  'use strict';

  var GIFT_BOX_VARIANT_ID = 48092837904610;
  var GIFT_BOX_HANDLE = 'gift-box-packing';
  var nativeFetch = window.fetch.bind(window);
  var enforcing = false;
  var scheduled = null;
  var noticeTimer = null;

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function showLimitNotice() {
    var id = 'BehuliGiftBoxLimitNotice';
    var notice = document.getElementById(id);
    if (!notice) {
      notice = document.createElement('div');
      notice.id = id;
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');
      notice.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:999999;background:#111;color:#fff;padding:12px 18px;border-radius:8px;font-size:14px;line-height:1.35;box-shadow:0 8px 24px rgba(0,0,0,.2);max-width:calc(100vw - 32px);text-align:center;';
      document.body.appendChild(notice);
    }
    notice.textContent = 'Only one gift box can be added per order.';
    notice.hidden = false;
    window.clearTimeout(noticeTimer);
    noticeTimer = window.setTimeout(function () { notice.hidden = true; }, 2800);
  }

  function giftBoxRowFrom(node) {
    var row = node && node.closest ? node.closest('tr, .cart-item, cart-item, [data-cart-item], .cart-drawer-item') : null;
    if (!row) return null;
    var productLink = row.querySelector('a[href*="/products/' + GIFT_BOX_HANDLE + '"]');
    return productLink ? row : null;
  }

  function clampVisibleControls() {
    document.querySelectorAll('a[href*="/products/' + GIFT_BOX_HANDLE + '"]').forEach(function (link) {
      var row = giftBoxRowFrom(link);
      if (!row) return;

      row.querySelectorAll('input[type="number"], input[name="updates[]"]').forEach(function (input) {
        input.max = '1';
        if (Number(input.value) > 1) input.value = '1';
      });

      row.querySelectorAll('button[name="plus"], .quantity__button[name="plus"], button[data-action="increase"]').forEach(function (button) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('title', 'Maximum one gift box per order');
      });
    });
  }

  async function enforceGiftBoxLimit(showNotice) {
    if (enforcing) return false;
    enforcing = true;
    var corrected = false;

    try {
      var cartResponse = await nativeFetch(rootUrl() + 'cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!cartResponse.ok) return false;

      var cart = await cartResponse.json();
      var giftItems = (cart.items || []).filter(function (item) {
        return Number(item.variant_id) === GIFT_BOX_VARIANT_ID;
      });

      for (var index = 0; index < giftItems.length; index += 1) {
        var item = giftItems[index];
        var allowedQuantity = index === 0 ? 1 : 0;
        if (Number(item.quantity) === allowedQuantity) continue;

        var changeResponse = await nativeFetch(rootUrl() + 'cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ id: item.key, quantity: allowedQuantity })
        });

        if (changeResponse.ok) corrected = true;
      }

      if (corrected) {
        clampVisibleControls();
        if (showNotice) showLimitNotice();
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          detail: { source: 'behuli-gift-box-limit' }
        }));
      }
    } catch (error) {
      console.error('[Behuli] Could not enforce gift box quantity limit.', error);
    } finally {
      enforcing = false;
    }

    return corrected;
  }

  function scheduleEnforcement(showNotice) {
    window.clearTimeout(scheduled);
    scheduled = window.setTimeout(function () {
      enforceGiftBoxLimit(showNotice).then(clampVisibleControls);
    }, 80);
  }

  window.fetch = async function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCartMutation = /\/cart\/(add|change|update)(\.js)?(?:\?|$)/.test(url);
    var response = await nativeFetch(input, init);
    if (isCartMutation) scheduleEnforcement(true);
    return response;
  };

  document.addEventListener('click', function (event) {
    var plusButton = event.target && event.target.closest
      ? event.target.closest('button[name="plus"], .quantity__button[name="plus"], button[data-action="increase"]')
      : null;

    if (plusButton && giftBoxRowFrom(plusButton)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showLimitNotice();
      enforceGiftBoxLimit(false);
    }
  }, true);

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !giftBoxRowFrom(target)) return;
    if ((target.matches('input[type="number"]') || target.matches('input[name="updates[]"]')) && Number(target.value) > 1) {
      target.value = '1';
      showLimitNotice();
      scheduleEnforcement(false);
    }
  }, true);

  document.addEventListener('cart:refresh', function (event) {
    if (event.detail && event.detail.source === 'behuli-gift-box-limit') {
      clampVisibleControls();
      return;
    }
    scheduleEnforcement(false);
  });

  function initGiftBoxLimit() {
    clampVisibleControls();
    enforceGiftBoxLimit(false);
    new MutationObserver(function () {
      clampVisibleControls();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftBoxLimit, { once: true });
  } else {
    initGiftBoxLimit();
  }
})();